import { Form, Group, UseMelioFormResults } from '@melio/penny';
import { Bill } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import React from 'react';

import { PaymentFlowFormFields, PaymentFlowOnChangeHandlers } from '../../../../types';
import { getExpectedBalance } from './utils';

type AmountInputProps = {
  form: UseMelioFormResults<PaymentFlowFormFields>;
  onChange: PaymentFlowOnChangeHandlers['onAmountChange'];
  isReadOnly: boolean;
  bill?: Bill;
};

export const AmountInput = ({ form, onChange, isReadOnly, bill }: AmountInputProps) => {
  const { formatMessage, formatCurrency } = useMelioIntl();
  const { registerField, watch } = form;
  const [amountToPay] = watch(['amountToPay']);

  const expectedBalance = bill && getExpectedBalance(bill, amountToPay);

  const helperPartialAmountText =
    expectedBalance && expectedBalance < bill.balance
      ? {
          label: formatMessage('activities.paymentFlow.form.content.amountToPay.partialPayment.helperText', {
            remainingAmount: formatCurrency(expectedBalance),
          }),
        }
      : undefined;

  return (
    <Group width="full" variant="vertical" spacing="xs">
      <Form.AmountField
        {...registerField('amountToPay')}
        labelProps={{ label: formatMessage('activities.paymentFlow.form.content.amountToPay.label') }}
        integerLimit={6}
        decimalLimit={2}
        allowNegativeValue={false}
        onBlur={() => amountToPay && onChange(amountToPay)}
        isReadOnly={isReadOnly}
        helperTextProps={helperPartialAmountText}
      />
    </Group>
  );
};
